class InPageNavigation {
  constructor() {
    this.selectors = {
      component: '.inPageNavigation',
      navTargets: '[data-nav-target="true"]',
      rtxt: '.text-row-wysiwyg',
    };
  }

  prepareTextRowNavTargets() {
    const rtxtH2s = $(this.selectors.rtxt).find('h2');
    rtxtH2s.each((index, header) => {
      $(header).attr('id', `rtxt-h2-${index}`);
      $(header).attr('data-nav-target', 'true');
    });
  }

  populateWidget() {
    if ($(this.selectors.rtxt).length > 0) {
      this.prepareTextRowNavTargets();
    }

    $(this.selectors.navTargets).each((index, target) => {
      const targetID = $(target).attr('id');
      let h2Title;
      if ($(target).find('h2').first().length === 0) {
        h2Title = $(target).text();
      } else {
        h2Title = $(target).find('h2').first().text();
      }
      const navItem = `<li>
          <a href="#${targetID}" class="button button--no-border has-icon round">${h2Title} <span class="chevron-right"></span></a>
        </li>`;

      $(this.selectors.component).find('ul').append(navItem);
    });
  }

  init() {
    this.populateWidget();
  }
}

export default new InPageNavigation();
